module.exports = __webpack_public_path__ + "static/media/custom-bg-2.51930e08.png";